<template>
  <button class="Wdgt-Auth-Back-Button">
    <ArrowStrong />
  </button>
</template>

<script setup>
  import ArrowStrong from '@shared/UI/SVG/ArrowStrong.vue';
</script>

<style lang="scss">
  @import './styles/_conf.scss';
</style>